import { useCallback, useState } from "react"
import { useDispatch } from "react-redux"
import { MainThunkDispatch, MainThunkResult } from "../Reducers"

interface UseModal<M> {
    modal: M | undefined
    isSaving: boolean
    open: (modal: M) => void
    close: () => void
    save: (action: MainThunkResult<unknown>) => void
}

export function useModal<M extends {}>(initial?: M): UseModal<M> {
    const [modal, setModal] = useState<M | undefined>(initial)
    const [isSaving, setSaving] = useState(false)
    const close = useCallback(() => setModal(undefined), [])
    const dispatch = useDispatch<MainThunkDispatch>()
    const save = useCallback(
        async (action: MainThunkResult<unknown>) => {
            try {
                setSaving(true)
                await dispatch(action)
                setModal(undefined)
            } finally {
                setSaving(false)
            }
        },
        [dispatch]
    )

    return { modal, isSaving, open: setModal, close, save }
}
